"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiConfig_1 = require("../config/ApiConfig");
var ApiManager_1 = require("../ApiManager");
/**
 * 회원가입 api
 * @param token
 * @param userId
 * @param password
 * @param auth : 성인 인증창 확인 유무
 * @param code : 파트너 코드
 * @param is17 : 17금 (구글) 파트너 코드 유무
 * @param deviceId : 고유값
 */
var ApiSignUp = /** @class */ (function (_super) {
    __extends(ApiSignUp, _super);
    function ApiSignUp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.SIGN_UP_URL = '/auth/SignUp';
        _this.signUpProc = function (token, isAlreadyMature, request, cToken) {
            var _a;
            var data = {
                userId: request.userId,
                password: request.password,
                auth: request.auth,
                is17: request.is17,
                deviceId: request.deviceId,
                partnerCode: request.partnerCode,
                cToken: cToken !== null && cToken !== void 0 ? cToken : '',
            };
            if (((_a = data.partnerCode) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                delete data.partnerCode;
            }
            return ApiConfig_1.Axios.Client({
                header: {
                    isAlreadyMature: isAlreadyMature,
                    token: token,
                },
                method: 'post',
                url: _this.SIGN_UP_URL,
                data: data,
            });
        };
        return _this;
    }
    ApiSignUp.getInstance = function (initValue) {
        if (!ApiSignUp.classInstance) {
            this.classInstance = new ApiSignUp(initValue);
        }
        return this.classInstance;
    };
    return ApiSignUp;
}(ApiManager_1.ApiManager));
exports.default = ApiSignUp;
